import { createSlice } from '@reduxjs/toolkit';

export interface ThemeState {
  themeColor: string;
  themeLogo: any;
}

const initialState: ThemeState = {
  themeColor: '#6E759F',
  themeLogo: ''
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    changeTheme(state, action) {
      state.themeColor = action.payload.updatetheme;
      state.themeLogo = action.payload.uploadLogo;
    }
  }
});

export const { changeTheme } = themeSlice.actions;
export default themeSlice.reducer;
